import React from "react";

import baner from "../img/BANNER.jpg";
import logo from "../img/lgo.png";

function Confirmacion() {
  const style = {
    background: "rgb(53, 145, 237)",
    fontFamily: "Roboto, sans-serif",
  };

  return (
    <>
      <style>
        {`
          body {
            margin: 0;
            padding: 0;
            font-family: "Arial", sans-serif;
            background: url("${baner}") center/cover no-repeat;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
          }

          .container {
            display: flex;
            margin: auto;
            width: 100%;
            padding-top: 25vh;
            align-items: center;
            color: rgb(255, 255, 255);
          }

          h3, h2 {
            font-size: 40px;
            margin-bottom: 10px;
            margin-top: 0px;
            text-align: center;
            user-select: none;
          }

          hr {
            width: 65%;
          }

          p:nth-last-child(2) {
            font-size: 18px;
            font-family: Arial, Helvetica, sans-serif;
            margin-bottom: 0;
            user-select: none;
            text-align: center;
          }

          p:last-child {
            font-size: 18px;
            font-family: Arial, Helvetica, sans-serif;
            user-select: none;
            text-align: center;
            margin-bottom: 50px;
          }

          p span a {
            text-decoration: none;
            color: #0000ff8f;
          }

          p span a:hover {
            color: #575151;
          }

          @media screen and (max-width: 1200px) {
            img {
              width: 450px;
              margin: 10px;
            }
          }

          @media screen and (max-width: 1200px) {
            img {
              width: 400px;
              margin: 10px;
            }
            h3, h2 {
              font-size: 20px;
            }
          }

          @media screen and (max-width: 800px) {
            .container {
              flex-direction: column;
              padding-top: 5vh;
            }
            h3, h2 {
              font-size: 30px;
            }
          }

          .card {
            background-color: #ffffff;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            overflow: hidden;
            max-width: 600px;
            width: 100%;
            padding: 20px;
            box-sizing: border-box;
          }

          .card img {
            max-width: 100%;
            height: auto;
          }

          .text-contents {
            color: #002e5d;
          }

          h3, h2, p {
            margin: 0;
            padding: 0;
          }

          h3 {
            font-size: 24px;
          }

          h2 {
            font-size: 18px;
            margin-top: 10px;
          }

          hr {
            margin: 15px 0;
            border: 0;
            border-top: 1px solid #ffffff;
          }

          p {
            font-size: 16px;
            line-height: 1.5;
          }

          a {
            color: #012142;
            text-decoration: none;
            font-weight: bold;
          }

          a:hover {
            text-decoration: underline;
          }
        `}
      </style>

      <div className="card">
        <center>
          <img src={logo} alt="women crying" width="300px" />
        </center>
        <div className="text-contents">
          <hr />
          <h3>Hemos enviado la confirmacion a tu correo electronico!!!</h3>
          <h2>Por favor revisar el correo</h2>
        </div>
      </div>
    </>
  );
}

export default Confirmacion;
